import React, { Component } from "react";
import { getSystemInfo } from "@/utils/common";
import { getMode } from "../codemirror/languages";

interface IMenuProps {
  isExpand: boolean;
  value: string;
  language: string;
  theme: string;
  title: string;
}

export default class CodeViewer extends Component<IMenuProps, any> {
  container = null;

  $cm = null;

  constructor(props) {
    super(props);
    this.state = {
      isExpand: props.isExpand,
      isInit: null,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.initCodeViewer();
    }, 20);
  }

  initCodeViewer = () => {
    const { value = "", language, theme } = this.props;
    const { isMobile } = getSystemInfo();
    const inputStyle = isMobile ? "textarea" : "contenteditable";
    const readOnly = isMobile ? true : "nocursor";
    if ((window as any).CodeMirror) {
      const cm = new (window as any).CodeMirror(this.container, {
        value,
        tabSize: 2,
        // Half-period in milliseconds used for cursor blinking.
        // The default blink rate is 530ms.
        // By setting this to zero, blinking can be disabled.
        // A negative value hides the cursor entirely.
        cursorBlinkRate: -1,
        inputStyle,
        readOnly,
        theme,
        matchBrackets: true, // 括号高亮
        mode: getMode(language),
      });
      // 阻止浏览态代码块还能够被剪切。。。
      cm.on("cut", (c, e) => {
        e.preventDefault();
      });
      // 阻止移动端点击代码块唤起键盘
      this.$cm = cm.getWrapperElement();
      if (isMobile) {
        this.$cm.querySelector("textarea").setAttribute("disabled", "true");
      }
      this.$cm.style.cssText = !this.state.isExpand
        ? "height:0.1px !important"
        : "height:auto !important";
      this.setState({ isInit: true });
    }
  };

  handleClick = () => {
    if (!this.$cm) {
      this.setState({ isInit: false }, () => {
        // 不延迟loading效果出不来。。
        setTimeout(() => {
          this.initCodeViewer();
        }, 20);
      });
    } else {
      this.$cm.style.cssText = this.state.isExpand
        ? "height:0.1px !important"
        : "height:auto !important";
      this.setState({ isExpand: !this.state.isExpand });
    }
  };

  render() {
    const { isInit, isExpand } = this.state;
    const { title, language } = this.props;
    const iconClass =
      isInit === false ? "icon-loading" : isExpand ? "" : "collapse";
    return (
      <div>
        <div key="header" className="header">
          <div className={`title ${iconClass}`} onClick={this.handleClick}>
            {title}
          </div>
          <div className="language">{language}</div>
          {!isExpand && <div className="isNotExpand" />}
        </div>
        <div
          key="viewer"
          ref={(refs) => {
            this.container = refs;
          }}
        />
      </div>
    );
  }
}
